<div class="bar-lines-chart">

  <div class="chart" #chart>

  </div>


</div>
